<template>
  <main class="c-main">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <header class="card-header">
            <!-- <router-link :to="{ name: 'unitStore' }" class="btn btn-success">Добавить единицу измерения</router-link> -->
            <a
              @click="showCreateModal = true"
              class="btn btn-success router-link-exact-active open active cursor"
              >Добавить единицу измерения</a
            >
            <h4 class="pull-right">Единицы измерения</h4>
          </header>
          <div class="card-body">
            <table
              class="table table-bordered table-striped"
              id="serverDataTable"
            >
              <thead>
                <tr>
                  <th>Единица измерения</th>
                  <th>Единица измерения единст ч</th>
                  <th>Единица измерения множ ч</th>
                  <th>Действие</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(unit, index) in units" :key="index">
                  <td>{{ unit.title }}</td>
                  <td>{{ unit.titleSingular }}</td>
                  <td>{{ unit.titlePlural }}</td>
                  <td>
                    <a
                      @click="openEditModal(index)"
                      class="btn btn-warning cursor"
                      >Изменить</a
                    >

                    <!-- <router-link class="btn btn-warning" :to="{ name: 'unitUpdate', params: { unit_id: unit.id }}">Изменить</router-link> -->
                    <!-- <a href="javascript:void(0);"  @click="deleteUnit(unit.id)" class="btn btn-danger ml-1">Удалить</a> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="modal-mask" v-show="showCreateModal" transition="modal">
            <div class="modal-wrapper">
              <div class="modal-container">
                <ValidationObserver ref="form">
                  <div class="form-group">
                    <label>Единица измерения</label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      class="w-100"
                    >
                      <input
                        type="text"
                        class="form-control"
                        v-model="unit.ru_title"
                      />
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="form-group">
                    <label>Загаловок единст число</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="unit.ru_titleSingular"
                    />
                  </div>
                  <div class="form-group">
                    <label>Загаловок множ число</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="unit.ru_titlePlural"
                    />
                  </div>

                  <div
                    class="modal-footer"
                    style="justify-content: space-around"
                  >
                    <slot name="footer">
                      <button
                        class="modal-button btn btn-danger"
                        @click="showCreateModal = false"
                      >
                        Закрыть
                      </button>
                      <button
                        class="modal-button btn btn-success"
                        @click="unitStore()"
                      >
                        Сохранить
                      </button>
                    </slot>
                  </div>
                </ValidationObserver>
              </div>
            </div>
          </div>

          <div class="modal-mask" v-show="showEditModal" transition="modal">
            <div class="modal-wrapper">
              <div class="modal-container">
                <ValidationObserver ref="form2">
                  <b-tabs content-class="mt-3" fill>
                    <b-tab title="Категория" active>
                      <div class="form-group">
                        <label>Единица измерения</label>
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          class="w-100"
                        >
                          <input
                            type="text"
                            class="form-control"
                            v-model="unit.title"
                          />
                          <span class="text-danger text-sm">{{
                            errors[0]
                          }}</span>
                        </ValidationProvider>
                      </div>
                      <div class="form-group">
                        <label>Загаловок единст число</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="unit.titleSingular"
                        />
                      </div>
                      <div class="form-group">
                        <label>Загаловок множ число</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="unit.titlePlural"
                        />
                      </div>
                    </b-tab>
                    <b-tab title="Язык">
                      <div class="form-group">
                        <label>Язык</label>
                        <select
                          class="form-control"
                          @change="onSelectCategoryLang()"
                          v-model="unit.language"
                        >
                          <option disabled>Выберите тип</option>
                          <option
                            v-for="language in languages"
                            :value="language.lang"
                            :key="language.id"
                          >
                            {{ language.lang }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group" v-if="unit.language != null">
                        <div class="form-group">
                          <label>Заголовок [{{ unit.language }}]</label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="unit[unit.language + '_title']"
                          />
                        </div>
                        <div class="form-group">
                          <label
                            >Загаловок единст число [{{ unit.language }}]</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            v-model="unit[unit.language + '_titleSingular']"
                          />
                        </div>
                        <div class="form-group">
                          <label
                            >Загаловок множ число [{{ unit.language }}]</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            v-model="unit[unit.language + '_titlePlural']"
                          />
                        </div>
                      </div>
                    </b-tab>
                    <b-tab title="Существует">
                      <div
                        v-for="translation in unit.translations"
                        :key="translation.id"
                      >
                        <p>
                          [{{ translation.locale }}] - {{ translation.title }}
                        </p>
                      </div>
                    </b-tab>
                  </b-tabs>

                  <div
                    class="modal-footer"
                    style="justify-content: space-around"
                  >
                    <slot name="footer">
                      <button
                        class="modal-button btn btn-danger"
                        @click="showEditModal = false"
                      >
                        Закрыть
                      </button>
                      <button
                        class="modal-button btn btn-success"
                        @click="unitUpdate()"
                      >
                        Изменить
                      </button>
                    </slot>
                  </div>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { GET, DELETE, POST } from "@/shared/api";
export default {
  data() {
    return {
      showEditModal: false,
      showCreateModal: false,
      unit: {},
      units: [],
      languages: [],
    };
  },
  methods: {
    openEditModal(index) {
      this.unit = { ...this.units[index] };
      this.showEditModal = true;
    },
    getUnits() {
      GET([], "/unit", this, false).then((response) => {
        this.units = response;
      });
    },
    deleteUnit(id) {
      DELETE(id, "/unit/", this).then((response) => {
        this.getUnits();
        this.showCreateModal = false;
      });
    },
    unitStore() {
      this.$refs.form.validate().then((success) => {
        if (success) {
          POST(this.unit, "/unit", this).then((response) => {
            this.getUnits();
            this.unit = {};
            this.showCreateModal = false;
          });
        }
      });
    },
    unitUpdate() {
      this.$refs.form2.validate().then((success) => {
        if (success) {
          POST(this.unit, "/unitUpdate", this).then((response) => {
            this.getUnits();
            this.showEditModal = false;
          });
        }
      });
    },
    getLanguages() {
      GET([], "/language", this, false).then((response) => {
        this.languages = response;
      });
    },
    onSelectCategoryLang() {
      for (let index = 0; index < this.unit.translations.length; index++) {
        if (this.unit.translations[index].locale == this.unit.language) {
          this.unit[this.unit.language + "_title"] =
            this.unit.translations[index].title;
          this.unit[this.unit.language + "_titleSingular"] =
            this.unit.translations[index].titleSingular;
          this.unit[this.unit.language + "_titlePlural"] =
            this.unit.translations[index].titlePlural;
        }
      }
    },
  },
  mounted() {
    this.getUnits();
    this.getLanguages();
  },
};
</script>
